const CLASSNAME = 'form'; // ?should this be implemented
const phoneRegex = '^$|^\\+?[0-9\\s\\-()]{7,20}$';
const passwordRegex = '^$|^(?=.*\\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[^a-zA-Z0-9])(?!.*\\s).{8,}$';

const FORM_SCHEMA = {
  type: 'object',
  properties: {
    // --- Your details
    email: {
      fieldId: 'email',
      info: true,
      label: 'email address',
      text: '&{value}',
      showInForm: true,
      section: 0
    },
    firstname: {
      fieldId: 'firstname',
      label: 'First name',
      showInForm: true,
      formFieldType: 'text',
      placeholder: '',
      type: 'string',
      minLength: 1,
      errorMessage: 'Please fill this in',
      isRequired: true,
      section: 0,
      group: 'name'
    },
    lastname: {
      fieldId: 'lastname',
      label: 'Last name',
      showInForm: true,
      formFieldType: 'text',
      placeholder: '',
      type: 'string',
      minLength: 1,
      errorMessage: 'Please fill this in',
      isRequired: true,
      section: 0,

      group: 'name'
    },
    jobTitle: {
      fieldId: 'jobTitle',
      label: 'Job title',
      showInForm: true,
      formFieldType: 'text',
      placeholder: '',
      type: 'string',
      minLength: 1,
      errorMessage: 'Please fill this in',
      isRequired: true,
      section: 0,
      group: 'occupation'
    },
    company: {
      fieldId: 'company',
      label: 'Organisation',
      showInForm: true,
      formFieldType: 'text',
      placeholder: '',
      type: 'string',
      minLength: 1,
      errorMessage: 'Please fill this in',
      isRequired: true,
      section: 0,
      group: 'occupation'
    },

    tel: {
      fieldId: 'tel',
      label: 'Telephone',
      showInForm: true,
      formFieldType: 'tel',
      placeholder: '',
      type: 'string',
      pattern: phoneRegex,
      errorMessage: `Please enter a valid telephone number`,
      isRequired: true,
      minLength: 1,
      section: 0,
      group: 'phone'
    },
    mobile: {
      fieldId: 'mobile',
      label: 'Mobile',
      showInForm: true,
      formFieldType: 'tel',
      placeholder: '',
      type: 'string',
      pattern: phoneRegex,
      errorMessage: `Please enter a valid mobile number`,
      section: 0,
      group: 'phone'
    },
    password: {
      fieldId: 'password',
      label: 'New password',
      showInForm: true,
      formFieldType: 'password',
      placeholder: '',
      type: 'string',
      autoComplete: 'new-password',
      pattern: passwordRegex,
      isRequired: false,
      errorMessage:
        'Must contain 8 or more characters with a mix of upper & lower case letters, numbers & symbols',
      section: 1,
      group: 'password'
    },
    passwordConfirm: {
      fieldId: 'passwordConfirm',
      label: 'Confirm new password',
      showInForm: true,
      formFieldType: 'password',
      placeholder: '',
      type: 'string',
      isRequired: false,
      group: 'password2',
      section: 1
    }
  },
  allOf: [
    {
      if: {
        properties: {
          password: { type: 'string' },
          passwordConfirm: { type: 'string' }
        },
        required: ['password', 'passwordConfirm']
      },
      then: {
        properties: {
          passwordConfirm: {
            const: { $data: '1/password' },
            errorMessage: {
              const: 'Password does not match'
            }
          }
        }
      }
    }
  ],

  required: ['firstname', 'lastname', 'jobTitle', 'company', 'tel'],
  sections: ['Your personal details', 'Change password']
};

export { CLASSNAME, FORM_SCHEMA };
